import React, { useEffect, useState } from "react";
import Footer from "../common/Footer";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { RegisterStepOne, RegisterStepTwo } from "../../api/Register";
import { tostE, tostS, tostW } from "../../config/tostConfig";
import { setProcessData, setStepData } from "../../redux/actions/processAction";
import { useLocation, useParams } from "react-router-dom";
import SaveAsDraftModal from "../common/SaveAsDraftModal";
import { PAN_REGEX } from "../../config/constant";
import { deleteIcon } from "../../assets/images";
import moment from "moment";

export default function DirectorInfo({
  handleBack = () => {},
  handleNext = () => {},
  handleTab = () => {},
  invalidForm = false,
  setInValidForm = () => {},
}) {
  const { user_id } = useParams();
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const { id, director, plan_history } = useSelector(
    (state) => state.process.data
  );
  const { data, currentMembership, step } = useSelector(
    (state) => state.process
  );
  const [loading, setLoading] = useState("");
  const [draftSaved, setDraftSaved] = useState(false);
  const [draftError, setDraftError] = useState(false);

  const basicDetailValidation = [
    "name",
    "email",
    "dob",
    "mobile_number",
    "state",
    "zone",
    "gst_number",
    "aadhar_proof",
    "pan_proof",
    "pan_number",
    "org_type",
    "company_name",
    "registered_address",
    "size_of_company",
    "incorporation_date",
    "primary_number",
    "moa",
    "aoa",
    "portaldirector",
    "resolution",
    "incorporation_certificate",
    "repersentative_photo",
    "deed",
    "authorization",
    "huf_authorization",
    "address_proof",
    "turnover_certificate",
  ];

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
    email: Yup.string()
      .required("Email is required")
      .email("Please enter a valid email"),
    dob: Yup.string().required("Date of birth is required"),
    mobile_number: Yup.string()
      .required("Whatsapp number is required")
      .min(6, "Please enter a valid number"),
    primary_number: Yup.string()
      .required("Primary number is required")
      .min(6, "Please enter a valid number"),
    state: Yup.string().required("State is required"),
    zone: Yup.string().required("Zone is required"),
    registered_address: Yup.string().required(
      "Registered Office address is required"
    ),
    size_of_company: Yup.string().required("Size of company is required"),
    incorporation_date: Yup.string().when(["org_type"], {
      is: (org_type) =>
        currentMembership &&
        currentMembership?.name.toLowerCase() !== "star" &&
        org_type &&
        org_type.toLowerCase() !== "huf",
      then: () => Yup.string().required("Incorporation date is required"),
      otherwise: () => Yup.string().notRequired(),
    }),
    // GST number optional if membership is star
    gst_number: Yup.string().when([], {
      is: () =>
        currentMembership && currentMembership?.name.toLowerCase() !== "star",
      then: () => Yup.string().required("GST number is required"),
      otherwise: () => Yup.string().notRequired(),
    }),
    aadhar_proof: Yup.string().when([], {
      is: () =>
        currentMembership && currentMembership?.name.toLowerCase() === "star",
      then: () => Yup.string().required("Aadhar Card is required"),
      otherwise: () => Yup.string().notRequired(),
    }),
    pan_proof: Yup.string().when([], {
      is: () =>
        currentMembership && currentMembership?.name.toLowerCase() === "star",
      then: () => Yup.string().required("PAN Card is required"),
      otherwise: () => Yup.string().notRequired(),
    }),
    pan_number: Yup.string()
      .required("PAN number is required")
      .matches(PAN_REGEX, "Please enter a valid PAN number"),
    org_type: Yup.string().when([], {
      is: () =>
        currentMembership && currentMembership?.name.toLowerCase() !== "star",
      then: () => Yup.string().required("Company type is required"),
      otherwise: () => Yup.string().notRequired(),
    }),
    company_name: Yup.string().required("Company name is required"),
    moa: Yup.string().when(["org_type"], {
      is: (org_type) => {
        return (
          currentMembership &&
          currentMembership?.name.toLowerCase() !== "star" &&
          org_type &&
          org_type.toLowerCase() === "company"
        );
      },
      then: () => Yup.string().required("MOA is required"),
      otherwise: () => Yup.string().notRequired(),
    }),
    aoa: Yup.string().when(["org_type"], {
      is: (org_type) => {
        return (
          currentMembership &&
          currentMembership?.name.toLowerCase() !== "star" &&
          org_type &&
          org_type.toLowerCase() === "company"
        );
      },
      then: () => Yup.string().required("AOA is required"),
      otherwise: () => Yup.string().notRequired(),
    }),
    portaldirector: Yup.string().when(["org_type"], {
      is: (org_type) => {
        return (
          currentMembership &&
          currentMembership?.name.toLowerCase() !== "star" &&
          org_type &&
          org_type.toLowerCase() === "company"
        );
      },
      then: () => Yup.string().required("Director Details is required"),
      otherwise: () => Yup.string().notRequired(),
    }),
    resolution: Yup.string().when(["org_type"], {
      is: (org_type) => {
        return (
          currentMembership &&
          currentMembership?.name.toLowerCase() !== "star" &&
          org_type &&
          org_type.toLowerCase() === "company"
        );
      },
      then: () => Yup.string().required("Resolution is required"),
      otherwise: () => Yup.string().notRequired(),
    }),
    incorporation_certificate: Yup.string().when(["org_type"], {
      is: (org_type) => {
        return (
          currentMembership &&
          currentMembership?.name.toLowerCase() !== "star" &&
          org_type &&
          org_type.toLowerCase() === "company"
        );
      },
      then: () =>
        Yup.string().required("Incorporation certificate is required"),
      otherwise: () => Yup.string().notRequired(),
    }),
    repersentative_photo: Yup.string().required(
      "Representative photo is required"
    ),
    deed: Yup.string().when(["org_type"], {
      is: (org_type) => {
        return (
          currentMembership &&
          currentMembership?.name.toLowerCase() !== "star" &&
          org_type &&
          org_type.toLowerCase() === "partnership"
        );
      },
      then: () => Yup.string().required("Deed is required"),
      otherwise: () => Yup.string().notRequired(),
    }),
    authorization: Yup.string().when(["org_type"], {
      is: (org_type) => {
        return (
          currentMembership &&
          currentMembership?.name.toLowerCase() !== "star" &&
          org_type &&
          org_type.toLowerCase() === "partnership"
        );
      },
      then: () => Yup.string().required("Authorization is required"),
      otherwise: () => Yup.string().notRequired(),
    }),
    huf_authorization: Yup.string().when(["org_type"], {
      is: (org_type) => {
        return (
          currentMembership &&
          currentMembership?.name.toLowerCase() !== "star" &&
          org_type &&
          org_type.toLowerCase() === "huf"
        );
      },
      then: () => Yup.string().required("Authorization is required"),
      otherwise: () => Yup.string().notRequired(),
    }),
    address_proof: Yup.string().required("Address proof is required"),
    turnover_certificate: Yup.string().when([], {
      is: () =>
        currentMembership && currentMembership?.name.toLowerCase() !== "star",
      then: () => Yup.string().required("Turnover certificate is required"),
      otherwise: () => Yup.string().notRequired(),
    }),
    director: Yup.array()
      .of(
        Yup.object().shape({
          name: Yup.string()
            .nullable()
            .test("name-required-if-any", "Name is required", function (value) {
              const { email, mobile_number } = this.parent; // Access sibling fields
              return (
                (!email && !mobile_number) ||
                ((!!email || !!mobile_number) && !!value)
              ); // Name is required if email or mobile number exists
            }),
          email: Yup.string()
            .nullable()
            .email("Please enter a valid email")
            .test(
              "email-required-if-name",
              "Email is required",
              function (value) {
                const { name } = this.parent; // Access sibling fields
                return !name || (name && value); // Email is required if name exists
              }
            ),
          mobile_number: Yup.string()
            .nullable()
            .min(6, "Please enter a valid mobile number")
            .test(
              "mobile-required-if-name",
              "Mobile number is required",
              function (value) {
                const { name } = this.parent; // Access sibling fields
                return !name || (name && value); // Mobile number is required if name exists
              }
            ),
        })
      )
      .test(
        "unique-email",
        "Email addresses must be unique",
        function (values) {
          const emails = values.map((item) => item.email).filter(Boolean);
          const uniqueEmails = new Set(emails);
          return emails.length === uniqueEmails.size;
        }
      )
      .test(
        "unique-mobile-number",
        "Mobile numbers must be unique",
        function (values) {
          const mobileNumbers = values
            .map((item) => item.mobile_number)
            .filter(Boolean);
          const uniqueMobileNumbers = new Set(mobileNumbers);
          return mobileNumbers.length === uniqueMobileNumbers.size;
        }
      )
      .test(
        "not-users-email",
        "You can't use your email as director's Email address",
        function (values) {
          const emails = values.map((item) => item.email).filter(Boolean);
          return !emails.includes(data.email);
        }
      )
      .test(
        "not-users-mobile-number",
        "You can't use your mobile number as director's mobile number",
        function (values) {
          const mobileNumbers = values
            .map((item) => item.mobile_number)
            .filter(Boolean);
          return !mobileNumbers.includes(data.mobile_number);
        }
      ),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: data.name ? data.name : "",
      email: data.email ? data.email : "",
      dob: data.dob ? data.dob : "",
      mobile_number: data.mobile_number ? data.mobile_number : "",
      state: data.state ? data.state : "",
      zone: data.zone ? data.zone : "",
      gst_number: data.gst_number ? data.gst_number : "",
      aadhar_proof: data.aadhar_proof ? data.aadhar_proof : "",
      pan_proof: data.pan_proof ? data.pan_proof : "",
      pan_number: data.pan_number ? data.pan_number : "",
      org_type: data.org_type ? data.org_type : "",
      company_name: data.company_name ? data.company_name : "",
      registered_address: data.registered_address
        ? data.registered_address
        : "",
      incorporation_date: data.incorporation_date
        ? data.incorporation_date
        : "",
      size_of_company: data.size_of_company ? data.size_of_company : "",
      primary_number: data.primary_number ? data.primary_number : "",
      same_number: data.same_number ? data.same_number : 0,
      moa: data.company && data.company.moa ? data.company.moa : "",
      aoa: data.company && data.company.aoa ? data.company.aoa : "",
      portaldirector:
        data.company && data.company.portaldirector
          ? data.company.portaldirector
          : "",
      resolution:
        data.company && data.company.resolution ? data.company.resolution : "",
      incorporation_certificate: data.incorporation_certificate
        ? data.incorporation_certificate
        : "",
      repersentative_photo: data.repersentative_photo
        ? data.repersentative_photo
        : "",
      deed: data.llp && data.llp.deed ? data.llp.deed : "",
      authorization:
        data.llp && data.llp.authorization ? data.llp.authorization : "",
      huf_deed: data.huf && data.huf.deed ? data.huf.deed : "",
      huf_authorization:
        data.huf && data.huf.authorization ? data.huf.authorization : "",
      address_proof: data.address_proof ? data.address_proof : "",
      turnover_certificate: data.turnover_certificate
        ? data.turnover_certificate
        : "",
      // director: (director && director.length) ? director : [{ name: "", email: "", mobile_number: "" }],
      director:
        director && director.length
          ? typeof director === "string"
            ? JSON.parse(director)?.length === 0
              ? [{ name: "", email: "", mobile_number: "" }]
              : JSON.parse(director)
            : director
          : [{ name: "", email: "", mobile_number: "" }],
    },
    validationSchema,
    onSubmit: async (values) => {
      if (!id) {
        tostW("Please submit basic details first!!");
        handleTab(1);
        return;
      }
      const body = {
        id,
        director: values.director.filter(
          (item) => item.name && item.email && item.mobile_number
        ).length
          ? values.director
          : null,
        is_draft: 0,
        is_admin: 1,
        journey: pathname.includes("upgrade") ? "upgrade" : "new",
      };
      if (data.app_id) {
        body.app_id = data.app_id;
      }

      setLoading("submit");
      try {
        if (step < 2) {
          let formData = new FormData();

          formData.set("id", id);
          formData.set("name", data.name);
          formData.set("email", data.email);
          formData.set("dob", moment(data.dob).format("YYYY-MM-DD"));
          formData.set("mobile_number", data.mobile_number);
          formData.set("state", data.state);
          formData.set("zone", data.zone);
          formData.set(
            "gst_number",
            data.gst_number &&
              data.gst_number !== null &&
              data.gst_number !== "null"
              ? data.gst_number
              : ""
          );
          formData.set("pan_number", data.pan_number);
          formData.set("company_name", data.company_name);
          formData.set("registered_address", values.registered_address);
          formData.set("size_of_company", values.size_of_company);
          formData.set("primary_number", values.primary_number);
          formData.set("same_number", values.same_number);
          formData.set("is_admin", 1);

          if (
            currentMembership &&
            currentMembership.name.toLowerCase() === "star"
          ) {
            formData.set("aadhar_proof", data.aadhar_proof);
            formData.set("pan_proof", data.pan_proof);
          }

          if (
            currentMembership &&
            currentMembership.name.toLowerCase() !== "star"
          ) {
            formData.set("org_type", data.org_type);
            formData.set(
              "incorporation_date",
              moment(values.incorporation_date).format("YYYY-MM-DD")
            );
            formData.set("turnover_certificate", data.turnover_certificate);
            if (data.org_type.toLowerCase() === "company") {
              formData.set("moa", data.company.moa);
              formData.set("aoa", data.company.aoa);
              formData.set("portaldirector", data.company.portaldirector);
              formData.set("resolution", data.company.resolution);
              formData.set(
                "incorporation_certificate",
                data.company.incorporation_certificate
              );
            }
            if (data.org_type.toLowerCase() === "partnership") {
              formData.set("deed", data.llp.deed);
              formData.set("authorization", data.llp.authorization);
            }
            if (values.org_type.toLowerCase() === "huf") {
              formData.set("deed", data.huf.deed);
              formData.set("authorization", data.huf.authorization);
            }
          }

          formData.set("repersentative_photo", data.repersentative_photo);
          formData.set("address_proof", data.address_proof);

          formData.set(
            "membership_id",
            currentMembership ? currentMembership.id : plan_history.plan_id
          );
          formData.set(
            "journey",
            data.history_type ? data.history_type : "new"
          );

          if (data.app_id) {
            formData.set("app_id", data.app_id);
          }

          const res1 = await RegisterStepOne(formData);
          if (res1.status === 200 && res1.data.success) {
            const res = await RegisterStepTwo(body);
            if (res.status === 200 && res.data.success) {
              tostS(res.data.message);
              dispatch(setProcessData({ ...res.data.data }));
              dispatch(setStepData(3));
              handleNext();
            } else {
              tostW(res.data.message);
            }
          }
        } else {
          const res = await RegisterStepTwo(body);
          if (res.status === 200 && res.data.success) {
            tostS(res.data.message);
            dispatch(setProcessData({ ...res.data.data }));
            dispatch(setStepData(3));
            handleNext();
          } else {
            tostW(res.data.message);
          }
        }
      } catch (error) {
        tostE(error.message);
      } finally {
        setLoading("");
      }
    },
  });

  const {
    values,
    setValues,
    errors,
    touched,
    handleSubmit,
    validateForm,
    setErrors,
    setTouched,
  } = formik;

  useEffect(() => {
    if (invalidForm) {
      validateForm().then((validationErrors) => {
        if (Object.keys(validationErrors).length > 0) {
          console.log(validationErrors);
          setErrors(validationErrors);
          // Handle nested structure for `touched`
          const touchedFields = Object.keys(validationErrors).reduce(
            (acc, key) => {
              const errorValue = validationErrors[key];
              if (Array.isArray(errorValue)) {
                // Handle array structure (e.g., director array)
                acc[key] = errorValue.map((item) => {
                  if (typeof item === "object") {
                    return Object.keys(item).reduce((nestedAcc, nestedKey) => {
                      nestedAcc[nestedKey] = true;
                      return nestedAcc;
                    }, {});
                  }
                  return true; // Default true for non-object items in the array
                });
              } else {
                acc[key] = true;
              }
              return acc;
            },
            {}
          );

          setTouched(touchedFields);
        }
      });
      setInValidForm(false);
    }
  }, [validateForm]); // eslint-disable-line

  const handleAddInput = () => {
    const updatedDirector = [
      ...values.director,
      { name: "", email: "", mobile_number: "" },
    ];

    setValues({
      ...values,
      director: updatedDirector,
    });

    dispatch(setProcessData({ director: updatedDirector }));
  };

  const handleInputChange = (e, idx) => {
    const { name, value } = e.target;
    const updatedDirector = values.director.map((director, index) =>
      index === idx ? { ...director, [name]: value } : director
    );
    setValues({
      ...values,
      director: updatedDirector,
    });
    dispatch(setProcessData({ director: updatedDirector }));
  };

  const handleDeleteInput = (index) => {
    const updatedDirector = values.director.filter((_, idx) => idx !== index);

    setValues({
      ...values,
      director: updatedDirector,
    });

    dispatch(setProcessData({ director: updatedDirector }));
  };

  return (
    <>
      <div className="membershipForm">
        <div className="director-info">
          <h3>FILL DIRECTOR DETAILS (Additional)</h3>
          <p>Provide details for additional directors beyond your own.</p>
        </div>
        {values.director &&
          Array.isArray(values.director) &&
          values.director.length &&
          values.director.map((item, idx) => (
            <div key={idx} className="row mb-3">
              <div className="col-md-3">
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    value={item.name}
                    placeholder="Director Name"
                    name="name"
                    onChange={(e) => {
                      handleInputChange(e, idx);
                    }}
                  />
                  {Array.isArray(touched.director) &&
                    touched.director.length &&
                    touched.director[idx]?.name &&
                    Array.isArray(errors.director) &&
                    errors.director.length &&
                    errors.director[idx]?.name && (
                      <p className="error">{errors.director[idx].name}</p>
                    )}
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <input
                    type="number"
                    className="form-control"
                    value={item.mobile_number}
                    placeholder="Mobile"
                    name="mobile_number"
                    onChange={(e) => {
                      if (e.target.value.length > 15) return;
                      handleInputChange(e, idx);
                    }}
                  />
                  {Array.isArray(touched.director) &&
                    touched.director.length &&
                    touched.director[idx]?.mobile_number &&
                    Array.isArray(errors.director) &&
                    errors.director.length &&
                    errors.director[idx]?.mobile_number && (
                      <p className="error">
                        {errors.director[idx].mobile_number}
                      </p>
                    )}
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <input
                    type="email"
                    className="form-control"
                    value={item.email}
                    placeholder="Email"
                    name="email"
                    onChange={(e) => {
                      handleInputChange(e, idx);
                    }}
                  />
                  {Array.isArray(touched.director) &&
                    touched.director.length &&
                    touched.director[idx]?.email &&
                    Array.isArray(errors.director) &&
                    errors.director.length &&
                    errors.director[idx]?.email && (
                      <p className="error">{errors.director[idx].email}</p>
                    )}
                </div>
              </div>
              <div className="col-md-2">
                {values.director.length > 1 && (
                  <button
                    className="btn btn-primary deleteBtn"
                    onClick={() => handleDeleteInput(idx)}
                  >
                    <img src={deleteIcon} alt="delete-icon" />
                  </button>
                )}
              </div>
            </div>
          ))}
        {touched.director &&
          errors.director &&
          typeof errors.director === "string" && (
            <p className="error mb-2">{errors.director}</p>
          )}
        {values.director.length < 5 && (
          <button
            type="button"
            className="btn btn-dark add-new"
            onClick={handleAddInput}
            disabled={values.director.length > 4}
          >
            Add New
          </button>
        )}
      </div>
      <Footer
        hideBackButton={user_id ? true : false}
        className={user_id ? "justify-content-end" : ""}
        isSaveAsDraft={false}
        isBackAllowed
        isNextAllowed={loading !== "submit"}
        backButtonAction={() => handleBack()}
        nextButtonText="Next"
        nextButtonAction={() => {
          formik.validateForm().then((errors) => {
            const invalidBasicDetail = Object.keys(errors).filter((key) =>
              basicDetailValidation.includes(key)
            );
            if (invalidBasicDetail.length > 0) {
              tostW("Please submit basic details first!!");
              handleTab(1);
              return;
            }
          });
          handleSubmit();
        }}
      />
      {(draftSaved || draftError) && (
        <SaveAsDraftModal
          handleCloseModal={() => {
            setDraftSaved(false);
            setDraftError(false);
          }}
          error={draftError}
        />
      )}
    </>
  );
}
